export var ChatType;
(function (ChatType) {
    ChatType["DIRECT"] = "direct";
    ChatType["GROUP"] = "group";
})(ChatType || (ChatType = {}));
